<template>
  <div>
    <headerSection></headerSection>
    <div class="x-main-content x-continue-page"
         :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
      <div class="container">

        <!-- Page Header -->
        <div class="x-page-header">
          <div class="x-page-title-component">
            <div class="-inner-wrapper">
              <div class="-icon-wrapper">
                <i class="fas fa-calendar-check"></i>
              </div>
              <h1 class="-title">ฝากต่อเนื่อง</h1>
            </div>
          </div>
          <p class="-description">ฝากทุกวันรับโบนัสพิเศษ</p>
        </div>

        <!-- Banner Image -->
        <!-- <div class="x-banner-section">
          <img src="https://firebasestorage.googleapis.com/v0/b/deltaplus-th.appspot.com/o/images%2F-Mz_mHdHPmA6AdSSde1r.png?alt=media&token=36a8a7d5-483b-4851-96e0-b38607a7d025" class="-banner-img" alt="ฝากต่อเนื่อง">
        </div> -->

        <!-- Main Content Card -->
        <div class="x-continue-card">
          <!-- Info Cards -->
          <div class="x-info-row">
            <div class="x-info-card">
              <div class="-icon-circle -promotion">
                <i class="fas fa-gift"></i>
              </div>
              <div class="-info-content">
                <span class="-label">โปรโมชั่น</span>
                <span class="-value">{{ (this.continues && this.continues.promotion) ? this.continues.promotion.name : 'ฝากต่อเนื่อง 7 วัน' }}</span>
              </div>
            </div>
            <div class="x-info-card">
              <div class="-icon-circle -bonus">
                <i class="fas fa-coins"></i>
              </div>
              <div class="-info-content">
                <span class="-label">โบนัสที่จะได้รับ</span>
                <span class="-value -gold">{{ numberWithCommas(this.continues.total) }}</span>
              </div>
            </div>
          </div>

          <!-- Progress Section -->
          <div class="x-progress-section">
            <div class="-progress-header">
              <span class="-text">ความคืบหน้า</span>
              <span class="-counter">{{ dots.length }}/7 วัน</span>
            </div>

            <!-- Visual Progress Track -->
            <div class="x-progress-track">
              <div class="-track-line">
                <div class="-track-fill" :style="{ width: progressPercentage + '%' }"></div>
              </div>
              <div class="-days-container">
                <div v-for="day in 7" :key="day" class="-day-item" :class="getDayClass(day)">
                  <div class="-day-circle">
                    <i v-if="dots[day - 1]" class="fas fa-check"></i>
                    <span v-else>{{ day }}</span>
                  </div>
                  <span class="-day-label">วัน {{ day }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Transfer Button -->
          <div class="x-action-section">
            <button
              class="x-transfer-btn"
              :class="{ '-disabled': !continues.total }"
              @click="moveContinuesToWallet()"
            >
              <i class="fas fa-exchange-alt"></i>
              <span>โอนเงินเข้ากระเป๋าหลัก</span>
            </button>
          </div>
        </div>

        <!-- Rules Section -->
        <div class="x-rules-card">
          <div class="-rules-header">
            <i class="fas fa-star"></i>
            <span>เงื่อนไขโปรโมชั่น</span>
          </div>
          <div class="-rules-content">
            <div class="-rule-item">
              <i class="fas fa-check-circle"></i>
              <span>สำหรับโปรฝากต่อเนื่อง 500 ติดต่อกัน 7 วัน รับไปเลย <strong class="-highlight">50 บ.</strong> เครดิตฟรี</span>
            </div>
            <div class="-rule-item">
              <i class="fas fa-check-circle"></i>
              <span>สำหรับโปรฝากต่อเนื่อง 1,000 ติดต่อกัน 7 วัน รับไปเลย <strong class="-highlight">100 บ.</strong> เครดิตฟรี</span>
            </div>
            <div class="-rule-item">
              <i class="fas fa-check-circle"></i>
              <span>ไม่ติดเทิร์นใดๆ</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'continues',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      continues: [],
      dots: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    progressPercentage () {
      return (this.dots.length / 7) * 100
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    getDayClass (day) {
      if (this.dots[day - 1]) {
        return '-completed'
      } else if (day === this.dots.length + 1) {
        return '-current'
      }
      return '-pending'
    },
    moveContinuesToWallet () {
      if (this.continues.total && this.continues.key) {
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally(async (res) => {
          if (this.user.credit <= 5) {
            let check = false
            await firebase.firestore().collection('history').where('userkey', '==', this.user.key).where('status', '==', 'กำลังดำเนินการ').where('type', '==', 'ถอน').limit(1).get().then((result) => {
              if (result.size) {
                check = true
              }
            })
            if (!check) {
              axios.get(`https://api.deltaplus-dp.com/qcontinuous/continuous/${this.continues.key}`)
              setTimeout(() => {
                this.getContinues()
                this.$store.commit('user/SET_LOADING', false)
              }, 2000)
            } else {
              this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'โปรดรอรายการถอนอนุมัติ' })
              this.$store.commit('user/SET_LOADING', false)
            }
          } else {
            this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ' })
            this.$store.commit('user/SET_LOADING', false)
          }
        }).catch(err => { console.error(err) })
      }
    },
    checkStyle () {
      if (this.continues && this.continues.total > 0) {
        return 'background: linear-gradient(180deg,#f9a25b , #f37320 );height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    async getContinues () {
      const user = this.getUserId()
      if (user) {
        await firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) {
            this.continues = []
            this.dots = []
          }
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.continues = data
          })
        })
        const fixed = 500
        let last = {}
        await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).orderBy('date', 'desc').limit(1).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            last = data
          })
        })
        const dateCheck = []
        if (last && last.date) {
          await firebase.firestore().collection('daily_deposit').where('createdate', '>', last.date).where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(7).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              if (doc.data().total >= fixed) {
                dateCheck[doc.data().createdate] = true
              }
            })
          })
        } else {
          await firebase.firestore().collection('daily_deposit').where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(7).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              if (doc.data().total >= fixed) {
                dateCheck[doc.data().createdate] = true
              }
            })
          })
        }
        if (dateCheck) {
          for (let i = 1; i <= 7; i++) {
            if (dateCheck[moment().tz('Asia/Bangkok').add(-i, 'days').format('YYYY-MM-DD')]) {
              this.dots.push(true)
            } else {
              break
            }
          }
        }
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getContinues()
  }
}
</script>
<style scoped>
.x-continue-page {
  min-height: 100vh;
  padding: 25px 0 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* Page Header */
.x-page-header {
  text-align: center;
  padding: 20px 0;
}

.x-page-title-component .-inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.x-page-title-component .-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ffe867 10%, #fe8a02);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(254, 195, 63, 0.5);
}

.x-page-title-component .-icon-wrapper i {
  font-size: 22px;
  color: #1b1b41;
}

.x-page-title-component .-title {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #ffc107;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.-description {
  color: #a0a0a0;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  margin-top: 10px;
}

/* Banner Section */
.x-banner-section {
  text-align: center;
  margin-bottom: 20px;
}

.x-banner-section .-banner-img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

/* Main Content Card */
.x-continue-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid #fec33f;
  border-radius: 20px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 0 30px rgba(254, 195, 63, 0.15);
}

/* Info Row */
.x-info-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 25px;
}

.x-info-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.-icon-circle {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.-icon-circle.-promotion {
  background: linear-gradient(180deg, #60a5fa, #3b82f6);
}

.-icon-circle.-bonus {
  background: linear-gradient(180deg, #fec33f, #fe8a02);
}

.-icon-circle i {
  color: #fff;
  font-size: 18px;
}

.-info-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.-info-content .-label {
  font-family: 'Kanit', sans-serif;
  font-size: 11px;
  color: #a0a0a0;
}

.-info-content .-value {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.-info-content .-value.-gold {
  color: #ffc107;
}

/* Progress Section */
.x-progress-section {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
}

.-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.-progress-header .-text {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  color: #fff;
}

.-progress-header .-counter {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #ffc107;
}

/* Progress Track */
.x-progress-track {
  position: relative;
}

.-track-line {
  position: absolute;
  top: 20px;
  left: 25px;
  right: 25px;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  z-index: 1;
}

.-track-fill {
  height: 100%;
  background: linear-gradient(90deg, #4ade80, #22c55e);
  border-radius: 2px;
  transition: width 0.5s ease;
}

.-days-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.-day-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.-day-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.-day-item.-pending .-day-circle {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: #a0a0a0;
}

.-day-item.-completed .-day-circle {
  background: linear-gradient(180deg, #4ade80, #22c55e);
  border: 2px solid #4ade80;
  color: #fff;
  box-shadow: 0 0 15px rgba(74, 222, 128, 0.4);
}

.-day-item.-current .-day-circle {
  background: linear-gradient(180deg, #fec33f, #fe8a02);
  border: 2px solid #fec33f;
  color: #1b1b41;
  animation: pulse-gold 1.5s ease-in-out infinite;
}

@keyframes pulse-gold {
  0%, 100% {
    box-shadow: 0 0 5px rgba(254, 195, 63, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(254, 195, 63, 0.8), 0 0 30px rgba(254, 195, 63, 0.4);
  }
}

.-day-label {
  font-family: 'Kanit', sans-serif;
  font-size: 10px;
  color: #a0a0a0;
}

.-day-item.-completed .-day-label {
  color: #4ade80;
}

.-day-item.-current .-day-label {
  color: #ffc107;
}

/* Action Section */
.x-action-section {
  text-align: center;
}

.x-transfer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 30px;
  background: linear-gradient(180deg, #f9a25b, #f37320);
  border: none;
  border-radius: 30px;
  color: #fff;
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(243, 115, 32, 0.4);
}

.x-transfer-btn:hover:not(.-disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(243, 115, 32, 0.5);
}

.x-transfer-btn.-disabled {
  background: linear-gradient(180deg, #666, #555);
  cursor: not-allowed;
  box-shadow: none;
}

.x-transfer-btn i {
  font-size: 16px;
}

/* Rules Card */
.x-rules-card {
  background: rgba(16, 16, 39, 0.95);
  border: 1px solid rgba(254, 195, 63, 0.3);
  border-radius: 20px;
  overflow: hidden;
}

.-rules-header {
  background: linear-gradient(180deg, #7a02fa, #5a01c0);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.-rules-header i {
  color: #ffc107;
  font-size: 16px;
}

.-rules-header span {
  font-family: 'Kanit', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.-rules-content {
  padding: 20px;
}

.-rule-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.-rule-item:last-child {
  border-bottom: none;
}

.-rule-item i {
  color: #4ade80;
  font-size: 14px;
  margin-top: 2px;
  flex-shrink: 0;
}

.-rule-item span {
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  color: #d0d0d0;
  line-height: 1.5;
}

.-rule-item .-highlight {
  color: #ffc107;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 576px) {
  .x-continue-card {
    padding: 15px;
  }

  .x-info-row {
    grid-template-columns: 1fr;
  }

  .-day-circle {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .-track-line {
    top: 16px;
    left: 16px;
    right: 16px;
  }

  .-day-label {
    font-size: 9px;
  }

  .x-page-title-component .-title {
    font-size: 20px;
  }

  .x-transfer-btn {
    padding: 10px 24px;
    font-size: 13px;
  }
}
</style>
